const mergeWith = require('lodash/mergeWith.js');

// 自定义合并规则（对象深度合并，数组覆盖）
function customMerge() {
  return mergeWith(...arguments, (left, right) =>
    Array.isArray(right) || Array.isArray(left) ? right : undefined
  );
}

function checkZero(v) {
  if (Math.abs(v) < 0.000001) v = 0;
  return v;
}

/**
 * 根据链接，格式化成所需要的 1x 链接，链接域名要求 oss 2x 图片, 并且后缀名需要是图片，如果已经指定转换格式或者尺寸，不再处理
 * @param {string} src 图片链接
 * @param {string} ratio 图片缩放百分比
 * @returns
 */
function formatImageSrc(src, ratio = 50) {
  let result = {
    src,
    isValid: false,
    src_1x: '',
  };
  if (!src) return result;
  if (typeof src !== 'string') return result;
  let obj = new URL(src);
  if (obj.hostname !== 'website.xdcdn.net') return result;
  const pathname = obj.pathname;
  const lastDotIndex = pathname.lastIndexOf('.');
  if (lastDotIndex < 0) return result;
  let ext = pathname.substring(lastDotIndex + 1).toLowerCase();
  if (ext !== 'png' && ext !== 'jpg' && ext !== 'jpeg') return result;
  const searchParams = obj.searchParams;
  let key = 'x-oss-process';
  let oriParam = searchParams.get(key); // 原始参数

  let paramArr = [];
  if (oriParam) {
    if (oriParam.indexOf('format') > -1) return result; // 已被要求转成其它格式
    if (oriParam.indexOf('resize') > -1) return result; // 已有尺寸要求，不宜转换
    paramArr = oriParam.split('/');
  }
  if (paramArr[0] !== 'image') paramArr.unshift('image');
  ratio = Math.min(Math.max(1, ratio), 100);
  paramArr.splice(1, 0, 'resize,p_' + ratio);

  searchParams.set(key, paramArr.join('/'));
  result.src_1x = obj.toString();
  result.isValid = true;
  result.srcset = getSrcset(result.src_1x, src);
  return result;
}

function getSrcset(src, srcRetina) {
  if (!src || !srcRetina) return '';
  return `${src} 1x, ${srcRetina} 2x`;
}

module.exports = {
  customMerge,
  checkZero,
  formatImageSrc,
};
